var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.6 9.4c1.7.3 3.2.9 4.6 2L21 8.5v7h-7l2.7-2.7C13 10.1 7.9 11 5.3 14.7c-.2.3-.4.5-.5.8L3 14.6c2.1-3.8 6.3-5.9 10.6-5.2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }